import React, { useEffect } from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import Home from './Home'
import StructureContainer from '../containers/structure/StructureContainer'
import Faculties from './faculties'
import LayoutContainer from '../containers/layout/LayoutContainer'
import Cathedra from './cathedra'
import GroupContainer from '../containers/group/GroupListContainer'
import Schedule from './schedule'
import ScheduleStudentContainer from '../containers/schedule/ScheduleStudentContainer'
import ScheduleOnDateContainer from '../containers/schedule/ScheduleOnDateContainer'
import ProgressContainer from '../containers/progress/ProgressContainer'
import Credits from './Credits/index'
import UmkContainer from '../containers/umk/UmkContainer'
import PlanContainer from '../containers/plan/PlanContainer'
import ReportContainer from '../containers/report/ReportContainer'
import Digital_rating from '../containers/DigitalRating/DigitalContainer'

import Dashboard from '../containers/Dashboard/DashboardContainer'
import Dashboard_listContainer from '../containers/Dashboard_list/Dashboard_listContainer'
import Dashboard_mtoContainer from '../containers/Dashboard_mto/Dashboard_mtoContainer'
import PersonalMain from '../containers/DashboardPersonal/DashboardPersonalContainer'
import PersonalMainMTO from '../containers/DashboardPersonalMTO/DashboardPersonalContainer'
import DashboardPersonalKaf from '../containers/DashboardPersonalKaf/DashboardPersonalKaf'
import IndicatorsDashbord from '../containers/DashbordIndicators/DashbordIndicatorsContainer'
import DashbordIndicatorsOrg from '../containers/DashbordIndicatorsOrg/DashbordIndicatorsOrgContainer'
import DashbordIndicatorsPers from '../containers/DashbordIndicatorsPers/DashbordIndicatorsPersContainer'
import DashbordIndicatorsInfo from '../containers/DashbordIndicatorsInfo/DashbordIndicatorsInfoContainer'
import DashbordIndicatorsActivity from '../containers/DashbordIndicatorsActivity/DashbordIndicatorsActivityContainer'

import DocumentListContainer from '../containers/document/DocumentListContainer'
import PortfolioContainer from '../containers/portfolio/PortfolioContainer'
import LKContainer from '../containers/lk/LKContainer'
import OrdersContainer from '../containers/orders/OrdersContainer'
import TrainingContainer from '../containers/training/TrainingContainer'
import PracticeContainer from '../containers/practice/PracticeContainer'
import DisciplinesContainer from '../containers/disciplines/DisciplinesContainer'
import DisciplineContainer from '../containers/disciplines/DisciplineContainer'
import ManagementContainer from '../containers/management/ManagementContainer'
import Certification from './certification'
import { EXAM_KIND } from '../utils/const'
import PermanentContainer from '../containers/permanentStuff/PermanentContainer'
import KTPListContainer from '../containers/ktp/KTPListContainer'
import ProgramContainer from '../containers/program/ProgramContainer'
import MetoRoomContainer from '../containers/metoRoom/MetoRoomContainer'
import PerformanceListContainer from '../containers/performance/PerformanceListContainer'
import PerformanceContainer from '../containers/performance/PerformanceContainer'
import ServiceTemporarilyUnavailableContainer from '../containers/ServiceTemporarilyUnavailableContainer/ServiceTemporarilyUnavailableContainer'
import NotFoundContainer from '../containers/notFound/NotFoundContainer'
import Messages from '../components/lk/Messages'
import ChatContainer from '../containers/lk/ChatContainer'
import CurriculumContainer from '../containers/curriculum/CurriculumContainer'
import UmkTeacherContainer from '../components/umk/UmkTeacher_.jsx'
import UmkCardContainer from '../containers/umk/UmkCardContainer'
import CurrentPerformance from '../containers/performance/CurrentPerformanceContainer'
import StudentProjects from '../containers/projects/StudentProjectsContainer'
import TeacherSchedule from './TeacherSchedule'
import BooksRequest from '../containers/booksRequest/booksRequestContainer'
import NewBookRequest from '../containers/newBookRequest/newBookRequestContainer'
import Personnel from './personnel/Personnel'
import DisciplineProgramsContainer from '../containers/educationWorkPrograms/EducationWorkProgramsContainer'
import DisciplineProgramsCardContainer from '../containers/educationWorkPrograms/EducationWorkProgramsCardContainer'
import VariableContainer from '../containers/variableStuff'
import ProgramModules from '../pages/ProgramModules'
import Topics from '../containers/Topics/TopicsContainer'
import TopicsView from '../containers/Topics/TopicsViewContainer'
import ComplexTopicsDisciplines from '../containers/complexTopicsDisciplines/complexTopicsDisciplinesContainer'
import ComplexTopicsDisciplinesView from '../containers/complexTopicsDisciplines/ComplexTopicsDisciplinesViewContainer'
import { Stream } from './Stream/Stream'
import FlowPlan from '../components/flow_plan'
import DashboardFaculties from '../components/dashboard/Faculties'
import DashboardPersonalMain from '../components/dashboard/PersonalMain/PersonalMain'

import DashboardPersonalMainMTO from '../components/dashboard/PersonalMainMTO/PersonalMain'
// import DashboardPersonalMainMTO from '../containers/DashboardPersonalMTO/DashboardPersonalContainer'
import DashboardPersonalKafMTO from '../containers/DashboardPersonalKafMTO/DashboardPersonalKaf'
import DashboardFacultiesMTO from '../components/dashboard/FacultiesMTO'
import FacultDashboardMTO from '../components/dashboard/FacultyStatMTO'
import ScheduleMTO from '../containers/scheduleMTO/ScheduleContainer'


import FacultDashboard from '../components/dashboard/FacultyStat'
import ScientificWorkContainer from '../containers/scientificWork/ScientificWorkContainer'
import SupportStudyDisContainer from '../containers/supportStudyDis/SupportStudyDisContainer'
import LessonPlanContainer from '../containers/lessonPlan/LessonPlanContainer'
import IndividualWorkPlanContainer from '../containers/individualWorkPlan/IndividualWorkPlanContainer'
import Testing from './Testing'
import CurrentTest from './CurrentTest'
import Grants from './Grants'
import GrantsTypes from './Grants/GrantTypes'
import MetoActivity from './MetoActivity'
import EncryptionKeys from './EncryptionKeys'
import Applicant from './Applicant'
import Announcement from './Announcement'
import { getLocalizeWords } from '../actions/auth'
import { connect } from 'react-redux'
import Criterias from '../containers/Criterias'
import Reviews from './Reviews'
import NewDashboard from '../containers/NewDashboard'
import CIUP from '../containers/NewDashboard/CIUP'
import EduProgram from '../containers/NewDashboard/EduProgram'
import EduProgramStructure from '../containers/NewDashboard/EduProgram/Structure'
import EduProgramOutcomesCompliance from '../containers/NewDashboard/EduProgram/OutcomesCompliance'
import EduProgramConditionsCompliance from '../containers/NewDashboard/EduProgram/ConditionsCompliance'
import AccessRoute from './AccessRoute'
import PrivateRoute from './PrivateRoute'
import InfoKiosk from './InfoKiosk'
import InfoTerminal from './InfoTerminal'
import InfoTerminalViewer from './InfoTerminalViewer'

import Journal from '../components/journal'

export const PATHS = {
  ROOT: '/',
  GUEST: {
    SEARCH: '/search',
  },
  AUTH: {
    UNITS: '/units',
    STUDIES: '/studies',
    TECHNIQUE: '/technique',
    DOCUMENTS: '/documents',
    FACULTY: '/faculty',
    CATHEDRA: '/cathedra',
    UMK: '/umk',
    UMKTEACHER: '/umkTeacher',
    UMKTEACHER_CARD: '/umkTeacher/:Id',
    CREDITS: '/credits',
    PROGRAM: '/program',
    SCHEDULE: '/schedule',
    SCHEDULE_STUDENT: '/schedule_student',
    SCHEDULE_ON_DATE: '/schedule_on_date',
    PERFORMANCES: '/performances',
    PERFORMANCE: '/performances/:semesterId/:courseId',
    CURRENT_PERFORMANCE: '/current_performance',
    STUDENT_PROJECTS: '/student_projects',
    STUDENT_PROJECTS_TEACHER: '/student_projects_teacher',
    FINAL_PERFORMANCE: '/final_performance',
    PORTFOLIO: '/portfolio',
    LIBRARY: '/library',
    TOPICS: '/topics',
    TOPICS_VIEW: '/topics/:id',
    COMPLEX_TOPICS_DISCIPLINES: '/complex_topics_disciplines',
    COMPLEX_TOPICS_DISCIPLINES_VIEW: '/complex_topics_disciplines/:id',

    GROUPS: '/groups',
    PROGRESS: '/progress',
    PLAN: '/plan',
    REPORT: '/report',
    TESTING: '/tests',
    DIGITAL_RATING: '/digital_rating',
    DASHBOARD: '/dashboard',
    DASHBOARD_INDICOTORS: '/dashboard/indicators',
    DASHBOARD_INDICOTORS_ORG: '/dashboard/indicators/org',
    DASHBOARD_INDICOTORS_PERS: '/dashboard/indicators/pers',
    DASHBOARD_INDICOTORS_INFO: '/dashboard/indicators/info',
    DASHBOARD_INDICOTORS_Activity: '/dashboard/indicators/activity/:id',
    DASHBOARD_LIST: '/dashboard/list',
    DASHBOARD_MTO: '/dashboard/mto',
    DASHBOARD_LIST_MINE: '/dashboard/list/:id',

    DASHBOARD_LIST_MINE_MTO: '/dashboard/mto/:id',

    DASHBOARD_LIST_MINE_KAF: '/dashboard/list/:id/kaf',
    DASHBOARD_LIST_MINE_FACS: '/dashboard/list/:id/facs',
    DASHBOARD_LIST_MINE_MAIN: '/dashboard/list/:id/main',

    DASHBOARD_LIST_MINE_KAF_MTO: '/dashboard/mto/:id/kaf',
    DASHBOARD_LIST_MINE_FACS_MTO: '/dashboard/mto/:id/facs',
    DASHBOARD_LIST_MINE_MAIN_MTO: '/dashboard/mto/:id/main',
    DASHBOARD_LIST_MINE_SCHEDULE_MTO: '/dashboard/mto/:id/schedule',
    FACULT_DASHBOARD_MTO: '/dashboard/mto/:id/facs/:facId',


    FACULT_DASHBOARD: '/dashboard/list/:id/facs/:facId/:cathId',
    EDUCATION_DOCUMENTS: '/education_documents',
    LK: '/lk',
    ORDERS: '/orders',
    TRAINING: '/training',
    PRACTICE: '/practice',
    DISCIPLINES: '/disciplines',

    DISCIPLINE: '/discipline/:cid/:idcurriculum/:syid/:eyid',

    MANAGEMENT: '/management',
    INTERMEDIATE_CERTIFICATION: '/intermediate_certification',
    FINAL_CERTIFICATION: '/final_certification',
    PERMANENT_STUFF: '/permanent_stuff',
    VARIABLE_STUFF: '/variable_stuff',
    KTP: '/ktp',
    METO_ROOM: '/meto_room',
    METO_ACTIVITY: '/meto_activity',
    MESSAGES: '/messages',
    CHAT: '/chat/:chatId/:toId',
    JOURNAL: {
      MAIN: '/journal',
      CURRENT_LESSON: '/journal/:lessonId',
      PLAN: '/journal/:lessonId/plan',
      HOMEWORK: '/journal/:lessonId/homework',
    },
    GRANTS: '/grants',
    GRANT_TYPES: '/grant_types',
    CURRICULUM: '/curriculum',
    TEACHER_SCHEDULE: '/teacher_schedule',
    BOOKS_REQUEST: '/booksrequest',
    NEW_BOOK_REQUEST: '/newbook',
    PERSONNEL: '/personnel',
    DISCIPLINE_PROGRAMS: '/disprograms',
    DISCIPLINE_PROGRAMS_CARD: '/disprograms/:Id',
    PROGRAM_MODULES: '/program_modules',
    STREAMS: '/streams',
    INPROCESS: '/inprocess',
    SCIENTIFIC_WORK: '/scientific_work',
    SUPPORT_STUDY_DIS: '/support_study_dis',
    LESSON_PLAN: '/lesson_plan',
    FLOW_PLAN: {
      LIST: '/flow_plan',
      CURRENT: '/flow_plan/:id',
    },
    TESTING: '/tests',
    CURRENT_TEST: '/tests/:testId',
    INDIDIVIDUAL_WORK_PLAN: '/Individual_work_plan',
    ENCRYPTION_KEYS: '/encryption_keys',
    APPLICANT: '/applicant',
    ANNOUNCEMENT: '/announcement',
    ANNOUNCEMENT_CURRENT: '/announcement/:id',
    SERVICE_TEMPORARILY_UNAVAILABLE: '/service_temporarily_unavailable',
    CRITERIAS: '/criterias',
    REVIEWS_LIST: '/reviews',
    REVIEWS_CURRENT: '/reviews/:id',
    INFO_KIOSK: '/info_kiosk',
    INFO_TERMINAL: '/Info_terminal',
    INFO_TERMINAL_VIEW: '/info_terminal_view',
    NEW_DASHBOARD: {
      MAIN: '/dashboard_new',
      ACCREDITATION: '/dashboard_new/accreditation',
      DETAILS: {
        MAIN: '/dashboard_new/details',
        EGE: '/dashboard_new/details/ege/:id',
        EIOC: '/dashboard_new/details/eioc/:id',
        TEACHERS: '/dashboard_new/details/teachers/:id',
        STAFF: '/dashboard_new/details/staff/:id',
        STUDENTS: '/dashboard_new/details/students/:id',
        VSOKO: '/dashboard_new/details/vsoko/:id',
      },
      DETAILS_SPO: {
        MAIN: '/dashboard_new/details_spo',
        EIOC: '/dashboard_new/details_spo/eioc/:id',
        STAFF: '/dashboard_new/details_spo/staff/:id',
        STUDENTS: '/dashboard_new/details_spo/students/:id',
        VSOKO: '/dashboard_new/details_spo/vsoko/:id',
      },
      CIUP: {
        MAIN: '/dashboard_new/ciup',
        MODES: '/dashboard_new/ciup/:mode',
        DETAILS: '/dashboard_new/ciup/:mode/:criterion',
      },
      EDU_PROGRAM: {
        MAIN: '/dashboard_new/edu_prog',
        STRUCTURE: '/dashboard_new/edu_prog/structure/:id',
        OUTCOMES_COMPLIANCE: '/dashboard_new/outcomes_compliance/:id',
        CONDITIONS_COMPLIANCE: '/dashboard_new/conditions_compliance/:id',
      }
    },
  },
}

const Routes = ({ getLocalizeWords }) => {

  useEffect(() => {
    getLocalizeWords('custom')
  }, [])

  return (
    <Router>

      <Switch>
        <PrivateRoute path={["/dashboard_new"]} render={(props) => (
          <NewDashboard.Layout {...props} >
            <Switch>
              <Route exact path={PATHS.AUTH.NEW_DASHBOARD.MAIN} component={NewDashboard.Main} />
              <Route exact path={PATHS.AUTH.NEW_DASHBOARD.ACCREDITATION} component={NewDashboard.Accreditation} />
              <Route
                path={PATHS.AUTH.NEW_DASHBOARD.DETAILS.MAIN}
                render={(props) => (
                  <NewDashboard.DetailsLayout {...props}>
                    <Switch>
                      <Route path={PATHS.AUTH.NEW_DASHBOARD.DETAILS.EGE} component={NewDashboard.EgeDetails} />
                      <Route path={PATHS.AUTH.NEW_DASHBOARD.DETAILS.EIOC} component={NewDashboard.EiocDetails} />
                      <Route path={PATHS.AUTH.NEW_DASHBOARD.DETAILS.TEACHERS} component={NewDashboard.TeachersDetails} />
                      <Route path={PATHS.AUTH.NEW_DASHBOARD.DETAILS.STAFF} component={NewDashboard.StaffDetails} />
                      <Route path={PATHS.AUTH.NEW_DASHBOARD.DETAILS.STUDENTS} component={NewDashboard.StudentsDetails} />
                      <Route path={PATHS.AUTH.NEW_DASHBOARD.DETAILS.VSOKO} component={NewDashboard.VsokoDetails} />
                    </Switch>
                  </NewDashboard.DetailsLayout>
                )}
              />
              <Route
                path={PATHS.AUTH.NEW_DASHBOARD.DETAILS_SPO.MAIN}
                render={(props) => (
                  <NewDashboard.DetailsSPOLayout {...props}>
                    <Switch>
                      <Route path={PATHS.AUTH.NEW_DASHBOARD.DETAILS_SPO.EIOC} render={(props) => <NewDashboard.EiocDetails {...props} spoMode />} />
                      <Route path={PATHS.AUTH.NEW_DASHBOARD.DETAILS_SPO.STAFF} render={(props) => <NewDashboard.StaffDetails {...props} spoMode />} />
                      <Route path={PATHS.AUTH.NEW_DASHBOARD.DETAILS_SPO.STUDENTS} render={(props) => <NewDashboard.StudentsDetails {...props} spoMode />} />
                      <Route path={PATHS.AUTH.NEW_DASHBOARD.DETAILS_SPO.VSOKO} render={(props) => <NewDashboard.VsokoDetails {...props} spoMode />} />
                    </Switch>
                  </NewDashboard.DetailsSPOLayout>
                )}
              />
              <Route exact path={PATHS.AUTH.NEW_DASHBOARD.CIUP.MAIN} component={NewDashboard.CIUP.Main} />
              {/* <Route path={PATHS.AUTH.NEW_DASHBOARD.CIUP.MODES} component={NewDashboard.CIUP.Details} /> */}
              <Route path={PATHS.AUTH.NEW_DASHBOARD.CIUP.DETAILS} component={NewDashboard.CIUP.Details} />
            
              <Route exact path={PATHS.AUTH.NEW_DASHBOARD.EDU_PROGRAM.MAIN} component={EduProgram} />
              <Route path={PATHS.AUTH.NEW_DASHBOARD.EDU_PROGRAM.STRUCTURE} component={EduProgramStructure} />
              <Route path={PATHS.AUTH.NEW_DASHBOARD.EDU_PROGRAM.OUTCOMES_COMPLIANCE} component={EduProgramOutcomesCompliance} />
              <Route path={PATHS.AUTH.NEW_DASHBOARD.EDU_PROGRAM.CONDITIONS_COMPLIANCE} component={EduProgramConditionsCompliance} />

            </Switch>
          </NewDashboard.Layout>
        )}>
        </PrivateRoute>
        <AccessRoute path={["/dashboard"]}>
          {/* <LayoutTwo> */}
          <Switch>
            <Route exact path={PATHS.AUTH.DASHBOARD} component={Dashboard} />
            <Route exact path={PATHS.AUTH.DASHBOARD_INDICOTORS} component={IndicatorsDashbord} />
            <Route exact path={PATHS.AUTH.DASHBOARD_INDICOTORS_ORG} component={DashbordIndicatorsOrg} />
            <Route exact path={PATHS.AUTH.DASHBOARD_INDICOTORS_PERS} component={DashbordIndicatorsPers} />
            <Route exact path={PATHS.AUTH.DASHBOARD_INDICOTORS_INFO} component={DashbordIndicatorsInfo} />
            <Route exact path={PATHS.AUTH.DASHBOARD_INDICOTORS_Activity} component={DashbordIndicatorsActivity} />
            <Route exact path={PATHS.AUTH.DASHBOARD_LIST} component={Dashboard_listContainer} />
            <Route exact path={PATHS.AUTH.DASHBOARD_MTO} component={Dashboard_mtoContainer} />
            <Route exact path={PATHS.AUTH.DASHBOARD_LIST_MINE} component={PersonalMain} />
            <Route exact path={PATHS.AUTH.DASHBOARD_LIST_MINE_MTO} component={PersonalMainMTO} />
            <Route exact path={PATHS.AUTH.DASHBOARD_LIST_MINE_KAF} component={DashboardPersonalKaf} />
            <Route exact path={PATHS.AUTH.DASHBOARD_LIST_MINE_FACS} component={DashboardFaculties} />
            <Route exact path={PATHS.AUTH.DASHBOARD_LIST_MINE_MAIN} component={DashboardPersonalMain} />

            <Route exact path={PATHS.AUTH.DASHBOARD_LIST_MINE_KAF_MTO} component={DashboardPersonalKafMTO} />
            <Route exact path={PATHS.AUTH.DASHBOARD_LIST_MINE_FACS_MTO} component={DashboardFacultiesMTO} />
            <Route exact path={PATHS.AUTH.DASHBOARD_LIST_MINE_MAIN_MTO} component={DashboardPersonalMainMTO} />
            <Route exact path={PATHS.AUTH.DASHBOARD_LIST_MINE_SCHEDULE_MTO} component={ScheduleMTO} />
            <Route exact path={PATHS.AUTH.FACULT_DASHBOARD_MTO} component={FacultDashboardMTO} />
            <Route exact path={PATHS.AUTH.FACULT_DASHBOARD} component={FacultDashboard} />
            <Route component={NotFoundContainer} />
          </Switch>
          {/* </LayoutTwo> */}
        </AccessRoute>
        <Route exact path={PATHS.AUTH.INFO_TERMINAL_VIEW} component={InfoTerminalViewer} />
        <Route path={["/"]}>
          <LayoutContainer>
            <Switch>
              <Route exact path={PATHS.AUTH.TEACHER_SCHEDULE} component={TeacherSchedule} />
              <Route exact path={PATHS.AUTH.STREAMS} component={Stream} />
              <Route exact path={PATHS.AUTH.BOOKS_REQUEST} component={BooksRequest} />
              <Route exact path={PATHS.AUTH.NEW_BOOK_REQUEST} component={NewBookRequest} />
              <Route exact path={PATHS.AUTH.TESTING} component={Testing} />
              <Route exact path={PATHS.AUTH.CURRENT_TEST} component={CurrentTest} />
              <Route exact path={PATHS.AUTH.LIBRARY} component={MetoRoomContainer} />
              <Route exact path={PATHS.AUTH.UNITS} component={StructureContainer} />
              {/* без exact: карточка живёт по адресу /faculty/:id и рисуется тем же
                  компонентом, поэтому при её закрытии перечень не перезагружается */}
              <Route path={PATHS.AUTH.FACULTY} component={Faculties} />
              {/* без exact: карточка кафедры живёт по /cathedra/:id и рисуется тем же
                  компонентом — при её закрытии перечень не перезагружается */}
              <Route path={PATHS.AUTH.CATHEDRA} component={Cathedra} />
              <Route exact path={PATHS.AUTH.GROUPS} component={GroupContainer} />
              <Route exact path={PATHS.AUTH.SCHEDULE} component={Schedule} />
              <Route exact path={PATHS.AUTH.SCHEDULE_STUDENT} component={ScheduleStudentContainer} />
              <Route exact path={PATHS.AUTH.SCHEDULE_ON_DATE} component={ScheduleOnDateContainer} />
              <Route exact path={PATHS.AUTH.PROGRESS} component={ProgressContainer} />
              <Route exact path={PATHS.AUTH.CREDITS} component={Credits} />
              <Route exact path={PATHS.AUTH.UMK} component={UmkContainer} />
              <Route exact path={PATHS.AUTH.UMKTEACHER} component={UmkTeacherContainer} />
              <Route exact path={PATHS.AUTH.UMKTEACHER_CARD} component={UmkCardContainer} />
              <Route exact path={PATHS.AUTH.DISCIPLINE_PROGRAMS} component={DisciplineProgramsContainer} />
              <Route exact path={PATHS.AUTH.DISCIPLINE_PROGRAMS_CARD} component={DisciplineProgramsCardContainer} />
              <Route exact path={PATHS.AUTH.PROGRAM_MODULES} component={ProgramModules} />
              <Route exact path={PATHS.AUTH.PLAN} component={PlanContainer} />
              <Route exact path={PATHS.AUTH.PORTFOLIO} component={PortfolioContainer} />
              <Route exact path={PATHS.AUTH.EDUCATION_DOCUMENTS} component={DocumentListContainer} />
              <Route exact path={PATHS.AUTH.LK} component={LKContainer} />
              <Route exact path={PATHS.AUTH.ORDERS} component={OrdersContainer} />
              <Route exact path={PATHS.AUTH.TRAINING} component={TrainingContainer} />
              <Route exact path={PATHS.AUTH.PRACTICE} component={PracticeContainer} />
              <Route exact path={PATHS.AUTH.DISCIPLINES} component={DisciplinesContainer} />
              <Route exact path={PATHS.AUTH.DISCIPLINE} component={DisciplineContainer} />
              <Route exact path={PATHS.AUTH.MANAGEMENT} component={ManagementContainer} />
              <Route
                exact
                path={PATHS.AUTH.INTERMEDIATE_CERTIFICATION}
                render={() => <Certification examKind={EXAM_KIND.INTERMEDIATE} />}
              />
              <Route
                exact
                path={PATHS.AUTH.FINAL_CERTIFICATION}
                render={() => <Certification examKind={EXAM_KIND.FINAL} />}
              />
              <Route exact path={PATHS.AUTH.TOPICS} component={Topics} />
              <Route exact path={PATHS.AUTH.TOPICS_VIEW} component={TopicsView} />
              <Route exact path={PATHS.AUTH.COMPLEX_TOPICS_DISCIPLINES} component={ComplexTopicsDisciplines} />
              <Route exact path={PATHS.AUTH.COMPLEX_TOPICS_DISCIPLINES_VIEW} component={ComplexTopicsDisciplinesView} />
              <Route exact path={PATHS.AUTH.PERMANENT_STUFF} component={PermanentContainer} />
              <Route exact path={PATHS.AUTH.VARIABLE_STUFF} component={VariableContainer} />
              <Route exact path={PATHS.AUTH.KTP} component={KTPListContainer} />
              <Route exact path={PATHS.AUTH.PROGRAM} component={ProgramContainer} />
              <Route exact path={PATHS.AUTH.METO_ROOM} component={MetoRoomContainer} />
              <Route exact path={PATHS.AUTH.METO_ACTIVITY} component={MetoActivity} />
              <Route exact path={PATHS.AUTH.MANAGEMENT} component={ManagementContainer} />
              <Route exact path={PATHS.AUTH.PERFORMANCES} component={PerformanceListContainer} />
              <Route exact path={PATHS.AUTH.PERFORMANCE} component={PerformanceContainer} />
              <Route exact path={PATHS.AUTH.CURRENT_PERFORMANCE} component={CurrentPerformance} />
              <Route exact path={PATHS.AUTH.STUDENT_PROJECTS} component={StudentProjects} />
              <Route exact path={PATHS.AUTH.STUDENT_PROJECTS_TEACHER} component={StudentProjects} />
              <Route exact path={PATHS.AUTH.FINAL_PERFORMANCE} component={PerformanceListContainer} />
              <Route exact path={PATHS.AUTH.MESSAGES} component={Messages} />
              <Route exact path={PATHS.AUTH.CHAT} component={ChatContainer} />
              <Route exact path={PATHS.AUTH.JOURNAL.MAIN} component={Journal.Main} />
              <Route exact path={PATHS.AUTH.JOURNAL.CURRENT_LESSON} component={Journal.CurrentLesson} />
              <Route exact path={PATHS.AUTH.JOURNAL.PLAN} component={Journal.Plan} />
              <Route exact path={PATHS.AUTH.JOURNAL.HOMEWORK} component={Journal.Homework} />
              <Route exact path={PATHS.AUTH.GRANTS} component={Grants} />
              <Route exact path={PATHS.AUTH.GRANT_TYPES} component={GrantsTypes} />
              <Route exact path={PATHS.AUTH.CURRICULUM} component={CurriculumContainer} />
              <Route exact path={PATHS.AUTH.PERSONNEL} component={Personnel} />
              <Route exact path={PATHS.AUTH.REPORT} component={ReportContainer} />
              <Route exact path={PATHS.AUTH.DIGITAL_RATING} component={Digital_rating} />
              <Route exact path={PATHS.AUTH.SCIENTIFIC_WORK} component={ScientificWorkContainer} />
              <Route exact path={PATHS.AUTH.SUPPORT_STUDY_DIS} component={SupportStudyDisContainer} />
              <Route exact path={PATHS.AUTH.LESSON_PLAN} component={LessonPlanContainer} />

              <Route exact path={PATHS.AUTH.ENCRYPTION_KEYS} component={EncryptionKeys} />
              <Route exact path={PATHS.AUTH.APPLICANT} component={Applicant} />
              <Route exact path={PATHS.AUTH.ANNOUNCEMENT} component={Announcement.List} />
              <Route exact path={PATHS.AUTH.ANNOUNCEMENT_CURRENT} component={Announcement.Current} />
              <Route exact path={PATHS.AUTH.CRITERIAS} component={Criterias} />
              <Route exact path={PATHS.AUTH.REVIEWS_LIST} component={Reviews.List} />
              <Route exact path={PATHS.AUTH.REVIEWS_CURRENT} component={Reviews.Current} />
              <Route exact path={PATHS.AUTH.INFO_KIOSK} component={InfoKiosk} />
              <Route exact path={PATHS.AUTH.INFO_TERMINAL} component={InfoTerminal} />

              <Route exact path={PATHS.AUTH.INDIDIVIDUAL_WORK_PLAN} component={IndividualWorkPlanContainer} />

              <Route exact path={PATHS.AUTH.FLOW_PLAN.LIST} component={FlowPlan.List} />
              <Route exact path={PATHS.AUTH.FLOW_PLAN.CURRENT} component={FlowPlan.Current} />
              <Route exact path={PATHS.AUTH.SERVICE_TEMPORARILY_UNAVAILABLE} component={ServiceTemporarilyUnavailableContainer} />
              <Route exact path={PATHS.ROOT} component={Home} />
              <Route component={NotFoundContainer} />
            </Switch>
          </LayoutContainer>
        </Route>
      </Switch>


    </Router>
  )
}

const mapStateToProps = state => {
  return {
    auth: state.auth,
  }
}

export default connect(mapStateToProps, { getLocalizeWords })(Routes)
